import { Dialog, DialogContent, Box, IconButton, Typography } from '@mui/material';
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import Iconify from '../Iconify';
import '../../css/users/successfullAddUserDialog.css';

const ActionBox = ({ icon, text, onClick }) => (
    <Box className='SuccessfulAddUser_action_box' onClick={onClick}>
        <Iconify icon={icon} className='SuccessfulAddUser_action_icon' />
        <Typography className='SuccessfulAddUser_action_title'>{text}</Typography>
    </Box>
);

export const SuccessfulAddUserDialog = ({ openSuccessfulAddUser, setOpenSuccessfulAddUser, userId }) => {

    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleNavigateToUserPage = useCallback(() => {
        navigate(`utilisateur_details/${userId}`);
    }, [userId, navigate]);

    const handleClose = useCallback(() => {
        setOpenSuccessfulAddUser(false);
    }, [setOpenSuccessfulAddUser]);

    return (
        <Dialog open={openSuccessfulAddUser} onClose={handleClose} classes={{ paper: 'SuccessfulAddUser_dialog' }}>
            <IconButton onClick={handleClose} className='SuccessfulAddUser_icon_button'>
                <Iconify icon={"material-symbols:close"} className='SuccessfulAddUser_close_icon' />
            </IconButton>
            <DialogContent className='SuccessfulAddUser_dialog_content' >
                <Iconify icon={"lets-icons:check-ring-light"} className='SuccessfulAddUser_check_icon' />
                <Typography className='SuccessfulAddUser_message'>{t('AddMachine_validation_message')}</Typography>
                <Box className='SuccessfulAddUser_action_container'>
                    <ActionBox
                        icon={"pepicons-pop:file"}
                        text={t('Page de l\'utilisateur')}
                        onClick={handleNavigateToUserPage}
                    />
                    <ActionBox
                        icon={"material-symbols-light:cards-outline"}
                        text={t('List des utilisateurs')}
                        onClick={handleClose}
                    />
                </Box>
            </DialogContent>
        </Dialog>
    );
};